import angular from 'angular';

import snapshotPreviewService from './snapshotPreviewService.factory';
import snapshotPreviewCtrl from './snapshotPreview.controller';

export default angular.module('app.snapshot.preview', [])
    .controller('snapshotPreviewCtrl', snapshotPreviewCtrl)
    .factory('SnapshotPreviewService', snapshotPreviewService);
